import { StyledTag } from '@framework/ui/components/tag/StyledTag.tsx';
import { useTranslation } from 'react-i18next';
import { PersonType } from './getPersonalDataItems.ts';

export interface IPersonTypeTagProps {
  type?: PersonType;
}

/**
 * Tag che indica il tipo di persona (Persona Fisica o Persona Giuridica).
 * Non renderizza nulla se il tipo non è definito.
 */
export function PersonTypeTag(props: Readonly<IPersonTypeTagProps>) {
  const { t } = useTranslation();
  if (!props.type) return null;

  const labels: Record<PersonType, string> = {
    [PersonType.Natural]: t(
      'submission-summary.type-persona-fisica',
      'Persona Fisica',
    ),
    [PersonType.Legal]: t(
      'submission-summary.type-persona-giuridica',
      'Persona Giuridica',
    ),
  };

  return <StyledTag>{labels[props.type]}</StyledTag>;
}
